module.exports = __webpack_public_path__ + "static/media/skynewsarabiaWhite.a2a7dc11.svg";